// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-select-class[data-v-2f24825c]  .vs__dropdown-option--selected,.vue-select-class[data-v-2f24825c]  .vs__dropdown-option--selected.vs__dropdown-option--highlight{color:#000!important;background-color:hsla(0,0%,86.3%,.4392156863)!important}", ""]);
// Exports
module.exports = exports;
